// asthmaMedicationsData.ts
export interface MedicationOption {
  id: string;
  label: string;
}

export interface MedicationGroup {
  id: string;
  title: string;
  singleSelect?: boolean;
  options: MedicationOption[];
}

export const MEDICATION_GROUPS: MedicationGroup[] = [
  {
    id: 'beta',
    title: 'אגוניסטים',
    singleSelect: true,
    options: [
      { id: 'ventolin05', label: 'ונטולין 0.5' },
      { id: 'trabotlin04', label: 'טרבוטלין 0.4' },
      { id: 'bricalin05', label: 'בריקלין 0.5' },
    ],
  },
  {
    id: 'anticholinergics',
    title: 'אנטיכולינרגים',
    singleSelect: true,
    options: [
      { id: 'arovent10', label: 'ארובנט 1.0 מ״ל' },
    ],
  },
  {
    id: 'steroids',
    title: 'סטרואידים',
    singleSelect: true,
    options: [
      { id: 'betamethasone02', label: 'בטנזול 0.2 מ"ג/ק"ג' },
      { id: 'dexcort06', label: 'דקסקורט 0.6 מ"ג/ק"ג' },
      { id: 'solumedrol2', label: 'סולומדרול במינון 2 מ"ג/ק"ג' },
      { id: 'budenizaide', label: 'בודנוזייד 2 מ"ג/מ"ל באינהלציה' },
      { id: 'deglon', label: 'דנלון 1 מ"ג/ק"ג (מקס 40 מ"ג)' },
      { id: 'prednisone', label: 'פרדניזון 1-2 מ"ג/ק"ג (מקס 60 מ"ג ליממה)' },
    ],
  },
  {
    id: 'route',
    title: 'דרך מתן',
    singleSelect: true,
    options: [
      { id: 'routeOral', label: 'פומית' },
      { id: 'routeIv', label: 'תוך ורידי' },
      { id: 'routeInhalation', label: 'אינהלציה' },
    ],
  },
  {
    id: 'fluids',
    title: 'עירוי נוזלים',
    options: [
      { id: 'ivFluids', label: 'עירוי נוזלים' },
    ],
  },
  {
    id: 'magnesium',
    title: 'מגנזיום',
    options: [
      { id: 'magnesium50', label: 'מגנזיום 50 מ״ג/ק״ג' },
    ],
  },
  {
    id: 'adrenaline',
    title: 'אדרנלין',
    options: [
      { id: 'adrenaline01', label: 'אדרנלין 0.1 מ״ג/ק״ג' },
    ],
  },
];

// default options
export const DEFAULT_SELECTED_IDS = ['ventolin05', 'arovent10', 'betamethasone02'];

export const DEFAULT_ENABLED_GROUPS = {
  beta: true,
  anticholinergics: true,
  steroids: true,
  route: true,
  fluids: false,
  magnesium: false,
  adrenaline: false,
};